import React, {Component} from 'react';
import ImageGallery from 'react-image-gallery';

import "react-image-gallery/styles/css/image-gallery.css";

class FullScreenPhotoGallery extends Component {

    buildImageObjects = () => {
        let results = [];
        this.props.images.forEach((image, index) => {
            results.push({original: image});
        });
        return results;
    }

    render() {
        return (
            <div style={{position: "absolute", top: 0, left: 0, right: 0, bottom: 0}}>
                <ImageGallery
                    items={this.buildImageObjects()}
                    slideInterval={3000} />
            </div>
        );
    }
}

export default FullScreenPhotoGallery;



// WEBPACK FOOTER //
// ./src/components/locator/details/FullScreenPhotoGallery.js